import type { WhatsappTemplate } from 'types/templates';

/** שם תצוגה בעברית (אליאס) — לא שם טכני של Meta */
export function getWhatsappTemplateHebrewDisplayName(template: WhatsappTemplate): string {
  const hn = template.hebrewName as
    | { hebrewTemaplateName?: string; HebrewTemaplateName?: string; createdAt?: string | null }
    | undefined;
  const display =
    hn?.hebrewTemaplateName?.trim() ||
    hn?.HebrewTemaplateName?.trim() ||
    template.hebrewName?.hebrewTemaplateName?.trim() ||
    '';
  return display || template.name;
}

/** חותמת זמן ליצירה — root או מוטמע ב-hebrewName */
export function getTemplateCreatedAtTime(template: WhatsappTemplate): number | null {
  const hn = template.hebrewName as { createdAt?: string | null } | undefined;
  const raw = template.createdAt ?? hn?.createdAt ?? null;
  if (!raw) return null;
  const t = new Date(raw).getTime();
  return Number.isNaN(t) ? null : t;
}
